<!-- Global Hero Header -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center 35%;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <span class="hero-badge">501(c)(3) Nonprofit</span>
    <h1 class="hero-title-global">Preserve 300+ Years of Heritage</h1>
    <p class="hero-subtitle">
      Your tax-deductible contribution protects St. Tammany’s oldest wooden schoolhouse, funds student field trips, and keeps our living traditions alive.
    </p>
  </div>
</header>

<main class="donate-container">
  <div class="donate-grid">
    <!-- Left Column: Impact Cards -->
    <div class="impact-column">
      <div class="trust-card">
        <h3>
          <mat-icon>volunteer_activism</mat-icon>
          Every Dollar Stays in Lacombe
        </h3>
        <p>
          The Bayou Lacombe Museum is entirely volunteer-guided and relies on community generosity to safeguard fragile artifacts, offer free educational admissions, and care for native gardens.
        </p>
      </div>

      <div class="impact-tiers-list">
        <h3>Choose Your Impact:</h3>
        <div 
          *ngFor="let tier of donationTiers"
          class="impact-card"
          [class.selected]="selectedAmount === tier.amount"
          (click)="selectTier(tier.amount)">
          <div class="tier-pill-col">
            <span class="tier-pill">${{ tier.amount }}</span>
          </div>
          <div class="tier-text-col">
            <h4>
              <mat-icon class="tier-icon">{{ tier.icon }}</mat-icon>
              {{ tier.label }}
            </h4>
            <p>{{ tier.impact }}</p>
          </div>
        </div>
      </div>

      <div class="nonprofit-info-card">
        <mat-icon>verified_user</mat-icon>
        <div>
          <h4>Tax-Deductible Contribution</h4>
          <p>The Bayou Lacombe Museum is a registered 501(c)(3) organization. Donations are tax-deductible to the extent allowed by law. Receipts are issued upon contribution.</p>
        </div>
      </div>
    </div>

    <!-- Right Column: Donation Form / Giving Portal -->
    <div class="form-column">
      <div class="giving-box" [hidden]="success">
        <h2>Make Your Gift</h2>
        <p class="giving-sub">Select a gift amount or specify your own below.</p>

        <!-- Amount Buttons -->
        <div class="amount-btn-group">
          <button 
            *ngFor="let tier of donationTiers"
            type="button"
            class="amount-btn"
            [class.active]="selectedAmount === tier.amount"
            (click)="selectTier(tier.amount)">
            ${{ tier.amount }}
          </button>
        </div>

        <!-- Custom Amount Input -->
        <div class="custom-amount-wrapper">
          <span class="currency-symbol">$</span>
          <input 
            type="number" 
            class="custom-amount-input" 
            placeholder="Other Amount (USD)" 
            min="5" 
            step="5"
            [value]="customAmount || ''"
            (input)="onCustomAmountInput($event)">
        </div>

        <!-- Donor Information Form -->
        <div class="donor-fields">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Your Name</mat-label>
            <input matInput [(ngModel)]="donorName" placeholder="e.g. Marie Delacroix" required>
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email Address</mat-label>
            <input matInput type="email" [(ngModel)]="donorEmail" placeholder="marie@example.com" required>
            <mat-icon matPrefix>email</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Optional Message or Project Preference</mat-label>
            <textarea matInput [(ngModel)]="donorMessage" rows="2" placeholder="e.g. In support of the Native Plant Gardens"></textarea>
          </mat-form-field>

          <!-- Dedication Toggle -->
          <div class="dedication-block">
            <label class="dedication-label">Dedicate this gift (optional):</label>
            <div class="radio-row">
              <label>
                <input type="radio" name="dedication" value="none" [(ngModel)]="dedicationType"> None
              </label>
              <label>
                <input type="radio" name="dedication" value="Honor" [(ngModel)]="dedicationType"> In Honor of
              </label>
              <label>
                <input type="radio" name="dedication" value="Memory" [(ngModel)]="dedicationType"> In Memory of
              </label>
            </div>
            <mat-form-field appearance="outline" class="full-width" *ngIf="dedicationType !== 'none'" style="margin-top: 0.5rem;">
              <mat-label>Honoree's Name</mat-label>
              <input matInput [(ngModel)]="dedicationName" placeholder="Name of honoree">
            </mat-form-field>
          </div>

          <div class="total-summary-card">
            <span>Total Gift Pledge:</span>
            <strong>${{ currentTotal }} USD</strong>
          </div>

          <button 
            type="button" 
            class="submit-gift-btn"
            [disabled]="currentTotal <= 0"
            (click)="submitPledge()">
            <mat-icon>favorite</mat-icon>
            <span>Proceed With Gift of ${{ currentTotal }}</span>
          </button>
        </div>
      </div>

      <!-- Success / Instructions View -->
      <div class="giving-box success-box" *ngIf="success">
        <mat-icon class="heart-icon">favorite</mat-icon>
        <h2>Thank You for Your Generosity!</h2>
        <p class="pledge-summary">
          Your gift pledge of <strong>${{ currentTotal }}</strong> provides critical support for the Bayou Lacombe Museum.
        </p>

        <!-- Direct Email Action Box -->
        <div class="email-action-box">
          <p class="email-action-desc">
            To coordinate your preferred payment method (Credit Card via Stripe, Check by Mail, or Bank Transfer) and receive your official 501(c)(3) tax receipt, click below:
          </p>
          <a [href]="mailtoLink" class="email-confirm-btn">
            <mat-icon>email</mat-icon>
            <span>Confirm Donation Pledge via Email</span>
          </a>
        </div>

        <div class="mail-check-card">
          <h4>
            <mat-icon>mail</mat-icon>
            Prefer to Mail a Check?
          </h4>
          <p>
            Please make checks payable to <strong>Bayou Lacombe Museum</strong> and mail to:<br>
            <strong>Bayou Lacombe Museum</strong><br>
            P.O. Box 755<br>
            Lacombe, LA 70445
          </p>
        </div>

        <div style="margin-top: 1.5rem; text-align: center;">
          <button mat-stroked-button color="primary" routerLink="/">Return to Homepage</button>
        </div>
      </div>
    </div>
  </div>
</main>
